// @flow
import React, { Component, type Node } from 'react';
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import styled, { type StyledComponent } from 'styled-components';

import { DSToken, FONT_FAMILY, Spacing } from '@rover/react-lib/styles';
import LabelAndErrorFormGroup from '@rover/react-lib/components/utils/LabelAndErrorFormGroup';

type IsFocusedProps = { isFocused?: boolean };

export const getBorderColor = ({ isFocused }: IsFocusedProps = {}) => {
  if (isFocused) {
    return DSToken.BORDER_COLOR_INPUT_FOCUS.toString();
  }
  return DSToken.BORDER_COLOR_PRIMARY.toString();
};
export const createStyledStripeElement = (
  StripeElement: CardNumberElement | CardExpiryElement | CardCVCElement
  // NOTE(Ryan) the weird syntax in the below styled() call is to prevent Stripe.js
  //            from complaining about receiving isFocused as an arg.
  //            See: https://github.com/styled-components/styled-components/issues/135
): StyledComponent<IsFocusedProps> => styled(({ isFocused, ...other }: IsFocusedProps) => (
  <StripeElement {...other} />
))`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  padding: ${Spacing.S};
  border: 1px solid ${props => getBorderColor(props)};
  border-radius: 4px;
  transition: border-color ease-in-out 0.15s;

  .__PrivateStripeElement {
    flex: 1;
  }
`;

export const stripeElementStyles = {
  base: {
    fontSize: '14px',
    color: DSToken.TEXT_COLOR_SECONDARY.toString(),
    fontFamily: FONT_FAMILY,
    '::placeholder': {
      color: DSToken.TEXT_COLOR_TERTIARY.toString(),
    },
  },
  invalid: {
    color: DSToken.TEXT_COLOR_SECONDARY.toString(),
  },
};

type State = {
  isFocused: boolean,
};

type RenderProps = {
  ...State,
  style: Object,
  onFocus: () => void,
  onBlur: () => void,
};

export type Props = {
  children: RenderProps => Node,
  validationError?: string,
};

export default class StripeFormGroup extends Component<Props, State> {
  state = {
    isFocused: false,
  };

  handleBlur = () => {
    this.setState(() => ({ isFocused: false }));
  };
  handleFocus = () => {
    this.setState(() => ({ isFocused: true }));
  };

  render() {
    const { children, ...other } = this.props;
    return (
      <LabelAndErrorFormGroup {...other}>
        {({ name, ...cleanInputProps }) => {
          const renderProps: RenderProps = {
            ...cleanInputProps,
            ...this.state,
            style: stripeElementStyles,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
          };
          return children(renderProps);
        }}
      </LabelAndErrorFormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/StripeCreditCardForm/StripeFormGroup.jsx